module.exports = __webpack_public_path__ + "static/media/textLogo.b07ca977.png";